// extracted by mini-css-extract-plugin
export default {"answersContainer":"AnswerOptionsList_answersContainer__KpoOi"};